import { useState } from 'react';
import { Link } from 'react-router-dom';
import { Button } from '../../../shared/components/Button';
import { EmptyState } from '../../../shared/components/EmptyState';
import { PageContainer } from '../../../shared/components/PageContainer';
import { Textarea } from '../../../shared/components/Textarea';
import { useToast } from '../../../shared/components/Toast';
import { mensagemDeErro } from '../api';
import { formatDate } from '../components/format';
import { PessoasModal } from '../components/PessoasModal';
import { useAfastamentosPendentes, useAprovarAfastamento, useRejeitarAfastamento } from '../hooks/afastamentos';

/** Afastamentos aguardando aprovação. Quem registrou não aprova. */
export default function AprovacoesAfastamentoPage() {
  const toast = useToast();
  const pendentes = useAfastamentosPendentes();
  const aprovar = useAprovarAfastamento();
  const rejeitar = useRejeitarAfastamento();
  const [rejecting, setRejecting] = useState<string | null>(null);
  const [reason, setReason] = useState('');

  async function run(action: () => Promise<unknown>, ok: string) {
    try {
      await action();
      toast.success(ok);
    } catch (err) {
      toast.error(mensagemDeErro(err, 'Não foi possível concluir a operação.'));
    }
  }

  const lista = pendentes.data ?? [];
  return (
    <PageContainer title="Aprovações de afastamento" breadcrumbs={[{ label: 'Pessoas' }, { label: 'Aprovações de afastamento' }]}>
      {lista.length === 0 ? (
        <EmptyState title="Nenhum afastamento aguardando aprovação" />
      ) : (
        <ul className="divide-y divide-gray-100 rounded-lg border border-gray-200 bg-white">
          {lista.map((l) => (
            <li key={l.id} className="flex flex-wrap items-center justify-between gap-2 px-4 py-3 text-sm">
              <div>
                <p className="font-medium text-gray-900">
                  <Link className="text-blue-700 hover:underline" to={`/pessoas/colaboradores/${l.userId}`}>{l.personName}</Link>
                  {' '}· matrícula {l.internalRegistration} · {l.typeName}
                </p>
                <p className="text-gray-700">{formatDate(l.startDate)} a {formatDate(l.expectedEndDate)} · registrado por {l.requestedByName ?? '—'}</p>
              </div>
              <span className="flex gap-2">
                <Button size="sm" onClick={() => run(() => aprovar.mutateAsync(l.id), 'Afastamento aprovado.')}>Aprovar</Button>
                <Button size="sm" variant="ghost" onClick={() => { setReason(''); setRejecting(l.id); }}>Rejeitar</Button>
              </span>
            </li>
          ))}
        </ul>
      )}
      <PessoasModal open={rejecting !== null} title="Rejeitar afastamento" submitLabel="Rejeitar" submitVariant="danger"
        canSubmit={reason.trim().length > 0} isSubmitting={rejeitar.isPending} onClose={() => setRejecting(null)}
        onSubmit={() => rejecting && run(async () => { await rejeitar.mutateAsync({ id: rejecting, reason: reason.trim() }); setRejecting(null); }, 'Afastamento rejeitado.')}>
        <Textarea label="Motivo" value={reason} onChange={(e) => setReason(e.target.value)} />
      </PessoasModal>
    </PageContainer>
  );
}
